import { defineStore } from 'pinia';

import { apiRequest, clearToken, getToken, saveToken } from '../api/client';

export const USER_STORAGE_KEY = 'cutepet-admin-user';

export interface SessionUser {
  id: number;
  orgId: number;
  orgCode: string;
  orgName: string;
  username: string;
  realName: string;
  roleType: string;
  orgExpireAt: string | null;
  orgExpiresInDays: number | null;
  orgExpiringSoon: boolean;
}

export function readStoredSessionUser(): SessionUser | null {
  const raw = window.localStorage.getItem(USER_STORAGE_KEY);
  return raw ? (JSON.parse(raw) as SessionUser) : null;
}

export function saveStoredSessionUser(user: SessionUser) {
  window.localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
}

export const useSessionStore = defineStore('session', {
  state: () => ({
    token: '',
    user: null as SessionUser | null,
  }),
  actions: {
    hydrate() {
      if (!this.token) {
        this.token = getToken();
      }
      if (!this.user) {
        this.user = readStoredSessionUser();
      }
    },
    async login(payload: { orgCode?: string; username: string; password: string }) {
      const data = await apiRequest<{
        accessToken: string;
        tokenType: string;
        expiresIn: number;
        user: SessionUser;
      }>('/auth/login', {
        method: 'POST',
        body: JSON.stringify(payload),
        quiet: true,
      });
      this.token = data.accessToken;
      this.user = data.user;
      saveToken(data.accessToken);
      saveStoredSessionUser(data.user);
      return data.user;
    },
    async fetchCurrentUser() {
      const user = await apiRequest<SessionUser>('/auth/me', { quiet: true });
      this.user = user;
      saveStoredSessionUser(user);
      return user;
    },
    logout() {
      this.token = '';
      this.user = null;
      clearToken();
      window.localStorage.removeItem(USER_STORAGE_KEY);
    },
  },
});
